import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";

import Lenis from 'lenis'
import Snap from 'lenis/snap'
import 'lenis/dist/lenis.css'

gsap.registerPlugin(ScrollTrigger);

const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

if (!reduceMotion) {
    gsap.to(".fade-in-box", {
        opacity: 1,
        y: 0,
        ease: "none",
        scrollTrigger: {
            trigger: ".fade-in-box",
            start: "top 0.75%",
            end: "top 0%",
            scrub: true,
        }
    });

    gsap.to("#stueck-sidebar", {
        scrollTrigger: {
            trigger: "#stueck-sidebar",
            start: "top 90%",
            end: "top 40%",
            scrub: true,
        },
        y: 0,
        opacity: 1,
        duration: 1.2,
        ease: "power3.out"
    });

    gsap.to("#stueck-auffuehrungen", {
        scrollTrigger: {
            trigger: "#stueck-auffuehrungen",
            start: "top 90%",
            end: "top 40%",
            scrub: true,
        },
        y: 0,
        opacity: 1,
        duration: 1.2,
        ease: "power3.out"
    });

    gsap.to("#scroll-close-button", {
        scrollTrigger: {
            trigger: "#scroll-close-button",
            start: "top 90%",
            end: "top 80%",
            scrub: true,
        },
        backgroundColor: "#000000",
        ease: "power3.out"
    });

    // Text- und Iconfarbe
    gsap.to("#scroll-close-button a", {
        scrollTrigger: {
            trigger: "#scroll-close-button",
            start: "top 90%",
            end: "top 85%",
            scrub: true,
        },
        color: "#ffffff",
        ease: "power3.out"
    });
} else {
    gsap.set([".fade-in-box", "#stueck-sidebar", "#stueck-auffuehrungen", "scroll-close-button"], { y: 0, opacity: 1 });
}

if (!reduceMotion) {

    const lenis = new Lenis()

    function raf(time) {
        lenis.raf(time)
        requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)

    const snap = new Snap(lenis, {
        distanceThreshold: '25%',
    })

    document.querySelectorAll('.snapping').forEach(elm => snap.addElement(elm, {
        align: ['start'], // 'start', 'center', 'end'
    }))
}